// Misc
import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'

// Utils
import { getWidgetURL } from 'utils/widget'

// Atoms
import Link from 'atoms/Link'

// Icons
import facebookSvg from 'assets/icons/facebook.svg'
import instagramSvg from 'assets/icons/instagram.svg'
import twitterSvg from 'assets/icons/twitter.svg'
import linkedinSvg from 'assets/icons/linkedin.svg'
import linkSvg from 'assets/icons/link.svg'

// Components
import StepSpacer from './StepSpacer'
import StepButton from './StepButton'
import StepParagraph from './StepParagraph'
import StepButtonIcon from './StepButtonIcon'

// Styles
const styles = {
  buttons: {
    marginBottom: -15 * 0.65,
    marginRight: -15 * 0.65,
    '& > *': {
      marginBottom: 15 * 0.65,
      marginRight: 15 * 0.65,
    }
  },
  hiddenLink: {
    height: 1,
    padding: 0,
    margin: 0,
    border: 0,
    opacity: 0,
    overflow: 'hidden',
    display: 'block',
  },
}

export default
@withStyles(styles)
class OnboardingFinishStepShareLinks extends Component {
  static propTypes = {
    meGetter: PropTypes.object.isRequired,
    classes: PropTypes.object.isRequired,
  }

  state = {
    copied: false,
    instructionFor: null,
  }

  copyToClipboard = () => {
    try {
      this.hiddenLink.select()
      document.execCommand('copy')
      window.getSelection().removeAllRanges()
      return true
    } catch (e) {
      return false
    }
  }

  showInstruction = instructionFor => () => {
    this.setState({
      copied: this.copyToClipboard(),
      instructionFor,
    })
  }

  hiddenLinkRef = (node) => {
    this.hiddenLink = node
  }

  renderHiddenLink() {
    const { classes, meGetter } = this.props
    const url = getWidgetURL(meGetter.data.business.domain)
    return (
      <input
        readOnly
        ref={this.hiddenLinkRef}
        className={classes.hiddenLink}
        value={url}
      />
    )
  }

  renderInstagramInstruction() {
    const { copied, instructionFor } = this.state
    return instructionFor === 'instagram' && (
      <Fragment>
        <StepSpacer extrasmall />
        <StepParagraph>
          { copied
            ? 'Link copied - now paste it in the \'website\' field of your '
            : 'Paste your link in the \'website\' field of your '
          }
          <StepButton
            underline
            component={Link}
            external
            target="_blank"
            to="https://www.instagram.com/accounts/edit/"
          >
            Instagram bio
          </StepButton>
        </StepParagraph>
      </Fragment>
    )
  }

  renderLinkedInInstruction() {
    const { copied, instructionFor } = this.state
    return instructionFor === 'linkedin' && (
      <Fragment>
        <StepSpacer extrasmall />
        <StepParagraph>
          { copied
            ? 'Link copied - now paste it in the \'website\' field of your LinkedIn bio'
            : 'Paste your link in the \'website\' field of your LinkedIn bio'
          }
        </StepParagraph>
      </Fragment>
    )
  }

  renderWebsiteInstruction() {
    const { copied, instructionFor } = this.state
    return instructionFor === 'website' && (
      <Fragment>
        <StepSpacer extrasmall />
        <StepParagraph>
          { copied
            ? 'Link copied - paste it anywhere!'
            : 'Paste your link anywhere!'
          }
        </StepParagraph>
      </Fragment>
    )
  }

  renderButtons() {
    const { classes, meGetter } = this.props
    const { domain, widgetConfig = {} } = meGetter.data.business
    const url = getWidgetURL(domain)
    const { welcomeMessage = '' } = widgetConfig
    const urlEncoded = encodeURIComponent(url)
    const welcomeMessageEncoded = encodeURIComponent(welcomeMessage)
    const buttons = [
      {
        key: 'facebook',
        icon: facebookSvg,
        component: Link,
        external: true,
        target: '_blank',
        to: `https://www.facebook.com/sharer.php?u=${urlEncoded}`
      },
      {
        key: 'instagram',
        icon: instagramSvg,
        onClick: this.showInstruction('instagram'),
      },
      {
        key: 'twitter',
        icon: twitterSvg,
        component: Link,
        external: true,
        target: '_blank',
        to: `https://twitter.com/intent/tweet?url=${urlEncoded}&text=${welcomeMessageEncoded}`
      },
      {
        key: 'linkedin',
        icon: linkedinSvg,
        onClick: this.showInstruction('linkedin')
      },
      {
        key: 'link',
        icon: linkSvg,
        onClick: this.showInstruction('website')
      },
    ]
    return (
      <div className={classes.buttons}>
        { buttons.map(link => (
          <StepButtonIcon {...link} />
        )) }
      </div>
    )
  }

  render() {
    return (
      <Fragment>
        { this.renderButtons() }
        { this.renderHiddenLink() }
        { this.renderInstagramInstruction() }
        { this.renderLinkedInInstruction() }
        { this.renderWebsiteInstruction() }
      </Fragment>
    )
  }
}
